import React from "react";
import { ArrowRight } from "lucide-react";
import { hero, about } from "../mock";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export function Hero() {
  return (
    <section id="home" className="pt-[104px] lg:pt-[128px] pb-20 lg:pb-28 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <p className="eyebrow mb-5">{hero.eyebrow}</p>
          <h1 className="font-display font-bold text-charcoal text-[34px] leading-[1.12] sm:text-5xl lg:text-[54px] lg:leading-[1.1] mb-7">
            {hero.title}
          </h1>
          <p className="text-body text-lg max-w-xl mb-9">{hero.description}</p>
          <div className="flex flex-wrap gap-4">
            <button onClick={() => scrollTo("contact")} className="btn-primary">
              Discuss Your Stand <ArrowRight size={18} />
            </button>
            <button onClick={() => scrollTo("work")} className="btn-outline">
              View Our Work
            </button>
          </div>
        </div>
        <div>
          <img
            src={hero.image}
            alt="Modern custom exhibition stand at a trade fair"
            className="w-full h-[320px] sm:h-[440px] lg:h-[520px] object-cover rounded-2xl shadow-lg"
          />
        </div>
      </div>
    </section>
  );
}

export function About() {
  return (
    <section id="about" className="section-pad bg-soft">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div className="order-2 lg:order-1">
          <img
            src={about.image}
            alt="Rainbow Worldwide design team collaborating on an exhibition stand plan"
            className="w-full h-[340px] lg:h-[460px] object-cover rounded-2xl shadow-md"
          />
        </div>
        <div className="order-1 lg:order-2">
          <p className="eyebrow mb-4">{about.eyebrow}</p>
          <h2 className="heading-2 mb-5">{about.heading}</h2>
          <p className="text-body text-lg mb-8">{about.intro}</p>
          <div className="space-y-7">
            {about.blocks.map((b, i) => (
              <div key={i}>
                <h3 className="font-display font-semibold text-charcoal text-lg mb-1.5">{b.title}</h3>
                <p className="text-body">{b.text}</p>
              </div>
            ))}
          </div>
          <button onClick={() => scrollTo("services")} className="btn-primary mt-9">
            Explore Our Services <ArrowRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
}
